function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.491 77.557c1.475.24 4.005 1.103 3.725 6.858-.152 3.144-2.492 3.753-3.649 3.55-3.66-.634-5.034-11.207-.076-10.408zM31.42 77.342c1.474.24 4.005 1.103 3.725 6.858-.153 3.144-2.492 3.752-3.649 3.55-3.661-.635-5.034-11.207-.076-10.408z",
  fill: "#804F21"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48.278 82.653c-1.805 0-3.42-.811-4.132-2.066-.203-.368-.305-.76-.394-1.14-.165-.698-.267-1.002-.635-1.154a1.386 1.386 0 00-.522-.115c-.635 0-1.233.685-1.856 1.395-.47.545-.966 1.103-1.563 1.47-.852.52-2.34 1.09-3.992 1.09-1.653 0-3.204-.608-4.285-1.749-2.072-2.193-2.466-5.299-1.068-8.519 1.793-4.132 6.827-8.531 12.65-8.531.305 0 .61 0 .915.038 3.23.266 6.662 2.446 8.747 5.552 2.034 3.017 2.568 6.478 1.526 9.71-.954 2.967-3.42 4.032-5.403 4.032l.012-.013z",
  fill: "#DE9C4C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.481 64.094c.28 0 .572 0 .852.038 5.657.457 11.862 7.2 9.599 14.25-.801 2.484-2.81 3.485-4.654 3.485-1.487 0-2.873-.646-3.458-1.673-.457-.799-.241-2.13-1.398-2.624a2.069 2.069 0 00-.826-.178c-1.602 0-2.518 2.18-3.827 2.992-.801.495-2.149.963-3.585.963-1.297 0-2.657-.392-3.725-1.508-5.175-5.464 2.453-15.745 11.01-15.745m.012-1.559c-6.217 0-11.43 4.526-13.362 9-1.525 3.525-1.08 6.935 1.22 9.369 1.234 1.306 2.925 2.003 4.857 2.003 1.818 0 3.471-.621 4.412-1.204.7-.431 1.246-1.065 1.742-1.623.394-.444.991-1.128 1.258-1.128.051 0 .127.025.216.05.051.064.128.393.178.622.102.418.204.887.47 1.343.853 1.496 2.734 2.46 4.82 2.46 2.262 0 5.06-1.205 6.152-4.564 1.12-3.474.534-7.163-1.627-10.382-2.25-3.347-5.823-5.616-9.344-5.895-.33-.026-.661-.038-.98-.038l-.012-.013z",
  fill: "#40220F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.472 79.839c2.225 2.345 5.772 1.483 7.297.545 1.526-.938 2.517-3.727 4.653-2.802 1.157.495.941 1.826 1.399 2.625 1.31 2.307 6.662 2.674 8.11-1.826 2.264-7.048-3.94-13.792-9.598-14.249-8.886-.722-17.2 10.066-11.861 15.707z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon_rick_2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34.09 80.46c1.411-1.927 3.166-5.514 6.764-6.516 3.598-1.001 7.018.545 7.959 2.447.94 1.901-.306 6.021-1.92 5.375-3.75-1.496-2.365-3.334-4.234-3.321-1.869.012-2.695 2.256-4.36 2.953-1.666.698-4.997-.038-4.997-.038",
  fill: "#804F21"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19 20.587c-2.633 0-5.989-1.23-7.514-4.677-1.26-2.827-1.272-6.275-.026-9.457 1.182-3.043 3.801-5.274 5.162-5.667.267-.076.534-.114.775-.114.649 0 1.767.292 2.022 2.218.368 2.726.928 6.314 1.424 9.495.597 3.816.953 6.187.991 6.77a.973.973 0 01-.292.735c-.598.634-1.984.697-2.543.697z",
  fill: "#DE9C4C"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.385 1.344c.788 0 1.208.583 1.36 1.635.776 5.616 2.352 15.086 2.416 16.201.025.393-.89.723-2.149.723-2.187 0-5.428-.976-6.903-4.285-1.017-2.307-1.335-5.565-.013-8.937 1.106-2.827 3.547-4.932 4.717-5.261.216-.064.407-.089.585-.089M17.384 0c-.305 0-.623.05-.954.14-1.754.494-4.437 3.055-5.606 6.059-1.31 3.347-1.284 6.972.038 9.977 1.665 3.752 5.289 5.083 8.136 5.083.814 0 2.276-.114 3.026-.913.33-.342.496-.786.47-1.23-.038-.62-.38-2.89-.991-6.832-.496-3.17-1.055-6.77-1.424-9.482C19.737.279 18.084 0 17.385 0z",
  fill: "#40220F"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.745 2.979c.776 5.616 2.352 15.085 2.416 16.201.063 1.116-6.738 1.673-9.052-3.55-1.017-2.307-1.335-5.565-.013-8.937 1.106-2.827 3.547-4.931 4.717-5.26 1.17-.33 1.767.253 1.945 1.546h-.013z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon_rick_2_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.509 4.919c-2.963 1.445-4.209 5.501-3.687 8.278a4.676 4.676 0 005.276 3.815L19.52 4.92h-.012z",
  fill: "#804F21"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M32.336 20.587c-.56 0-1.945-.063-2.542-.697a.991.991 0 01-.293-.735c.026-.583.394-2.954.992-6.77.496-3.169 1.055-6.769 1.424-9.495C32.184.964 33.303.672 33.938.672c.242 0 .496.038.776.114 1.36.38 3.979 2.612 5.161 5.667 1.233 3.182 1.233 6.617-.025 9.457-1.538 3.448-4.882 4.677-7.514 4.677z",
  fill: "#DE9C4C"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M33.95 1.344c.178 0 .37.025.585.088 1.17.33 3.61 2.422 4.717 5.261 1.322 3.372 1.004 6.63-.013 8.938-1.462 3.308-4.716 4.284-6.903 4.284-1.271 0-2.174-.33-2.149-.722.064-1.128 1.64-10.585 2.416-16.201.14-1.052.572-1.636 1.36-1.636M33.95 0c-.699 0-2.352.279-2.695 2.802-.368 2.712-.928 6.313-1.424 9.482-.61 3.955-.966 6.224-.991 6.833-.026.456.14.887.47 1.23.75.798 2.225.912 3.026.912 2.848 0 6.471-1.33 8.136-5.083 1.335-2.992 1.348-6.63.039-9.977-1.17-3.017-3.853-5.565-5.607-6.06A3.693 3.693 0 0033.95 0z",
  fill: "#40220F"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M32.59 2.979c-.775 5.616-2.352 15.085-2.415 16.201-.064 1.116 6.738 1.673 9.052-3.55 1.017-2.307 1.335-5.565.012-8.937-1.106-2.827-3.547-4.931-4.716-5.26-1.17-.33-1.768.253-1.946 1.546h.013z",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon_rick_2_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.828 4.919c2.962 1.445 4.208 5.501 3.686 8.278a4.676 4.676 0 01-5.276 3.815L31.815 4.92h.012z",
  fill: "#804F21"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M28.064 62.395c-6.586 0-13.197-1.901-18.587-5.337-7.883-5.032-11.023-16.72-6.713-25.024C7.811 22.3 16.189 20.372 18.643 20.017a53.02 53.02 0 017.437-.533c4.717 0 8.633.672 11.659 2.003 5.505 2.409 10.908 5.59 13.145 12.41 2.047 6.225.738 16.519-4.488 21.907-4.004 4.145-10.857 6.617-18.332 6.617v-.026z",
  fill: "#DE9C4C"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M26.08 20.232c3.777 0 7.972.457 11.341 1.927 5.912 2.599 10.68 5.705 12.726 11.955 2.009 6.11.534 16.125-4.31 21.132-3.954 4.082-10.577 6.376-17.786 6.376-6.077 0-12.56-1.635-18.18-5.223C2.663 51.798-.948 40.807 3.426 32.364c4.208-8.126 10.997-10.99 15.307-11.612a52.799 52.799 0 017.322-.532m.026-1.509c-3.331 0-6.154.342-7.552.545-2.543.368-11.239 2.37-16.451 12.424-4.551 8.785-1.36 20.7 6.98 26.013 5.517 3.524 12.268 5.463 19.006 5.463 7.793 0 14.671-2.497 18.88-6.845 5.403-5.59 6.776-16.24 4.665-22.667-2.339-7.111-7.895-10.382-13.565-12.867-3.115-1.369-7.145-2.066-11.963-2.066z",
  fill: "#40220F"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M9.884 56.412C2.676 51.81-.936 40.82 3.438 32.377c4.208-8.126 10.997-10.991 15.307-11.612 4.31-.621 12.752-1.192 18.676 1.407 5.925 2.599 10.68 5.705 12.726 11.954 2.047 6.25.534 16.125-4.31 21.133-7.297 7.53-23.697 8.988-35.953 1.153z",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon_rick_2_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.644 19.294c.534 4.45 3.28 13.488 4.094 12.64.813-.85 4.119-12.754 4.119-12.754-2.441.19-8.213.114-8.213.114z",
  fill: "#804F21"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M31.04 82.21c-.128 0-2.988 0-3.459-.939l-.089-.177c-.127-.279-.343-.76-.66-.95-.14.151-.331.48-.446.671-.241.406-.457.76-.775.95-.56.343-2.428.406-3.09.406-2.021 0-3.229-.38-3.687-1.153-1.83-3.043-.483-11.143.967-17.406 1.322-5.73 4.958-5.73 6.7-5.73h.267c2.886 0 6.483 0 7.755 5.73.953 4.26 2.835 14.503-.19 17.57-.815.837-2.239 1.002-3.28 1.002l-.014.026z",
  fill: "#DE9C4C"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M26.488 58.681h.267c2.86 0 5.848.038 6.98 5.122C34.79 68.53 36.365 78 33.746 80.65c-.572.583-1.665.773-2.72.773-1.348 0-2.645-.304-2.747-.507-.178-.355-.534-1.318-1.322-1.584a.75.75 0 00-.165-.025c-.7 0-1.195 1.533-1.602 1.787-.216.127-1.424.291-2.682.291-1.26 0-2.657-.177-3.014-.76-1.576-2.624-.52-9.99 1.056-16.822 1.17-5.058 4.08-5.122 5.924-5.122m.013-1.572c-1.793 0-6 0-7.463 6.339-2.161 9.317-2.454 15.364-.864 17.988.622 1.04 2.021 1.534 4.373 1.534.445 0 2.67-.025 3.496-.52.369-.215.623-.532.84-.874 0 .012.012.038.025.05.597 1.205 2.86 1.382 4.157 1.382 1.742 0 3.038-.418 3.852-1.242 3.178-3.22 1.615-12.855.407-18.306-1.411-6.35-5.696-6.35-8.53-6.35H26.487z",
  fill: "#40220F"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.402 30.133c2.759-.9 2.62 4.183.445 4.221-1.742.026-2.072-3.689-.445-4.221zM31.852 29.93c2.76-.9 2.62 4.184.445 4.222-1.741.025-2.072-3.69-.445-4.222zM25.458 34.24c2.759-.9 2.619 4.183.445 4.221-1.742.026-2.073-3.688-.445-4.22z",
  fill: "#000"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M26.767 62.282c-4.322 0-8.683-.9-12.255-2.548a.749.749 0 01-.318-.28c-2.34-3.486-1.92-14.07-1.894-14.527 0-.203.101-.406.254-.545a.79.79 0 01.521-.203h.356c4.145 0 11.646-3.309 12.167-4.424a.786.786 0 01.674-.457h.038a.78.78 0 01.674.393c.572.913 8.073 3.816 11.925 3.816h.216c.407 0 .75.317.775.723.102 1.23.903 12.106-.991 14.984a.85.85 0 01-.267.253C35.4 61.293 31.293 62.27 26.78 62.27l-.013.013z",
  fill: "#FBE0D0"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M26.297 40.097c.801 1.382 8.836 4.209 12.6 4.209h.216s.94 11.764-.865 14.502c-3.293 1.85-7.374 2.7-11.48 2.7-4.107 0-8.467-.887-11.938-2.472-2.225-3.321-1.767-14.058-1.767-14.058h.356c4.157 0 12.154-3.31 12.878-4.881zm0-1.56h-.076a1.544 1.544 0 00-1.31.837c-.927 1.129-7.78 4.044-11.492 4.044H13.063c-.394 0-.763.14-1.055.406a1.55 1.55 0 00-.509 1.09c-.05 1.154-.407 11.359 2.021 14.984.166.241.382.431.649.545 3.687 1.686 8.15 2.612 12.586 2.612 4.437 0 8.887-1.002 12.256-2.903.216-.127.407-.292.534-.507 1.996-3.03 1.271-13.425 1.119-15.479a1.561 1.561 0 00-1.551-1.432h-.216c-3.446 0-10.324-2.536-11.29-3.5a1.559 1.559 0 00-1.31-.709v.013z",
  fill: "#40220F"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M29.17 53.61c-.178 2.98-3.089 4.184-4.373.153.966-.178 4.373-.152 4.373-.152z",
  fill: "#D61518"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M28.37 53.61c0 .064 0 .14-.013.203 0 .026-.013.076 0 .102 0 0 .025-.178 0-.089l-.077.406c-.025.101-.063.203-.089.304a.873.873 0 00-.063.165c.076-.228.012-.038-.013.025l-.152.266c-.026.051-.064.09-.09.127-.05.089.128-.152 0 0-.063.063-.127.14-.19.203-.038.038-.076.063-.102.089-.05.05.102-.076.09-.076-.026 0-.064.05-.09.063-.064.038-.14.076-.203.114-.077.05.203-.063.038-.013-.051.013-.09.026-.14.038-.038 0-.076 0-.114.026.19-.076.165-.013.05 0h-.177c-.128 0 .076 0 .101.012-.076-.038-.165-.038-.241-.063-.026 0-.039-.013-.064-.025-.089-.026.178.088.089.038-.05-.026-.102-.05-.153-.076l-.114-.076c-.165-.114 0 .025.013.012-.026.013-.242-.228-.267-.253-.051-.05-.09-.102-.14-.165-.076-.05-.026-.025 0 0 .089.076 0 0-.026-.038-.088-.14-.178-.279-.254-.418-.038-.076-.089-.165-.127-.241-.025-.05-.127-.292-.064-.127a8.25 8.25 0 01-.216-.596l-.559.976s.076 0 .102-.012c.127-.026-.242.025-.051 0 .089 0 .165-.013.254-.026l.61-.038c.483-.025.967-.038 1.45-.038.597 0 1.195-.012 1.792 0 .42 0 .814-.367.788-.786-.025-.418-.343-.786-.788-.786h-1.843c-.903.013-1.844 0-2.734.178-.406.076-.673.596-.559.976.407 1.242 1.157 2.75 2.556 3.093 1.156.279 2.212-.38 2.784-1.356.368-.634.546-1.37.585-2.092.025-.418-.382-.811-.789-.786-.457.025-.763.342-.788.786l-.013-.025z",
  fill: "#D61518"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M32.692 69.051c.623 7.403-1.577 8.937-6.332 8.937-3.7 0-5.797-1.572-5.288-8.582.508-6.934 11.086-6.668 11.62-.355z",
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.11 46.486c2.759-.9 2.619 4.184.445 4.222-1.742.025-2.072-3.69-.445-4.222zM30.734 46.144c2.759-.9 2.619 4.183.445 4.221-1.742.026-2.072-3.689-.445-4.221z",
  fill: "#000"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M15.376 66.199c-3.357-1.978-6.052-5.071-7.527-6.795-1.601-1.876-1.27-3.829-.699-4.83.509-.875 2.873-1.94 3.738-.342.864 1.597 6.433 4.83 9.357 8.81.814 1.116-.407 5.78-4.882 3.144l.013.013z",
  fill: "#DE9C4C"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M8.714 52.735c.472-.109 1.01-.135 1.528.029a2.25 2.25 0 011.318 1.106c.138.257.537.673 1.241 1.276.678.58 1.526 1.242 2.473 2.006 1.748 1.41 3.787 3.131 5.293 5.054l.294.387.002.001.125.202c.26.492.294 1.126.225 1.674a4.177 4.177 0 01-.823 2.02 3.175 3.175 0 01-2.174 1.23c-.928.106-1.985-.157-3.166-.838-.02-.01-.042-.017-.061-.029-3.479-2.05-6.247-5.235-7.719-6.956H7.27c-1.84-2.156-1.487-4.464-.78-5.7l.002-.005.085-.132c.212-.304.52-.567.837-.771a4.174 4.174 0 011.301-.554zm1.067 1.478c-.185-.058-.432-.063-.723.004a2.643 2.643 0 00-.816.348c-.244.158-.381.305-.43.384l.002.001c-.438.767-.745 2.364.617 3.96l.606.703c1.529 1.75 3.875 4.238 6.687 5.906.009.004.019.007.027.012l.373.206c.838.43 1.467.523 1.918.471.5-.057.87-.304 1.145-.655a2.66 2.66 0 00.511-1.274c.06-.472-.033-.734-.068-.787l-.27-.355c-1.383-1.765-3.295-3.39-5.045-4.802-.918-.741-1.808-1.436-2.508-2.036-.674-.576-1.296-1.163-1.59-1.706a.73.73 0 00-.436-.38z",
  fill: "#40220F"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M8.803 57.92c-1.996 1.446-4.717-.037-5.696-1.888-.8-3.08.852-5.87 3.75-5.667 1.45.102 4.018.862 4.018 3.943 0 1.61-2.072 3.613-2.072 3.613z",
  fill: "#FBE0D0"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M10.113 54.308c0-1.29-.52-2.022-1.147-2.47-.667-.477-1.517-.67-2.161-.714-1.162-.082-2.036.424-2.565 1.252-.531.832-.739 2.037-.416 3.369.412.734 1.172 1.416 2.035 1.762.86.344 1.73.328 2.455-.175l.033-.032a10.183 10.183 0 00.879-1.032c.24-.327.47-.685.635-1.04.17-.36.252-.672.252-.92zm1.525 0c0 .556-.175 1.098-.395 1.566-.222.474-.512.92-.79 1.295a11.73 11.73 0 01-1.088 1.267l-.028.028v.002h-.002l-.531-.546.53.547a.768.768 0 01-.082.07c-1.263.914-2.733.873-3.962.381-1.138-.456-2.146-1.324-2.743-2.329l-.114-.203a.762.762 0 01-.036-.079l-.027-.084c-.445-1.71-.225-3.402.582-4.665.821-1.285 2.223-2.072 3.96-1.95.804.055 1.964.294 2.943.993 1.02.728 1.783 1.917 1.783 3.707z",
  fill: "#40220F"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M38.578 67.099c3.356-1.978 6.052-5.071 7.526-6.795 1.602-1.876 1.272-3.829.7-4.83-.509-.875-2.874-1.94-3.738-.342-.865 1.597-6.433 4.83-9.357 8.81-.814 1.116.407 5.78 4.882 3.144l-.013.013z",
  fill: "#DE9C4C"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M43.713 53.664c.517-.164 1.055-.138 1.527-.029.475.11.927.312 1.301.554.318.204.626.467.838.77l.085.133.002.005.128.244c.593 1.237.803 3.291-.742 5.253l-.167.203c-1.472 1.72-4.24 4.907-7.719 6.956-.022.013-.047.023-.07.034-1.178.677-2.232.939-3.158.833a3.174 3.174 0 01-2.173-1.23 4.176 4.176 0 01-.822-2.02c-.08-.627-.024-1.365.349-1.876h.002l.293-.388c1.506-1.923 3.545-3.644 5.293-5.054.947-.764 1.796-1.426 2.474-2.007.704-.602 1.102-1.019 1.24-1.275a2.25 2.25 0 011.319-1.106zm1.183 1.453c-.29-.067-.538-.062-.723-.004a.73.73 0 00-.435.38c-.294.543-.917 1.13-1.59 1.706-.701.6-1.59 1.295-2.509 2.036-1.867 1.506-3.918 3.255-5.315 5.157-.035.053-.127.316-.068.787.056.44.229.91.513 1.274.274.351.645.598 1.145.655.514.06 1.262-.072 2.289-.677l.032-.016c3.213-1.907 5.819-4.886 7.29-6.605l.235-.298c1.085-1.49.793-2.936.384-3.657l-.051-.07a1.709 1.709 0 00-.38-.32 2.647 2.647 0 00-.817-.348z",
  fill: "#40220F"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M45.164 58.833c1.996 1.446 4.716-.038 5.695-1.888.801-3.08-.852-5.87-3.75-5.667-1.45.101-4.018.862-4.018 3.943 0 1.61 2.073 3.612 2.073 3.612z",
  fill: "#FBE0D0"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M47.056 50.52c1.736-.122 3.137.666 3.959 1.95.756 1.185.997 2.746.658 4.345l-.076.32a.754.754 0 01-.063.164c-.577 1.09-1.643 2.045-2.857 2.532-1.152.461-2.516.525-3.722-.222l-.24-.16a.766.766 0 01-.083-.069l.531-.547-.531.546h-.001l-.002-.003-.027-.027a10.307 10.307 0 01-.327-.342 11.736 11.736 0 01-.762-.926 7.831 7.831 0 01-.79-1.295c-.219-.467-.394-1.01-.394-1.566 0-1.79.764-2.978 1.783-3.706.979-.7 2.139-.938 2.944-.994zm-3.203 4.7c0 .25.084.561.253.922.166.354.394.712.635 1.038a10.187 10.187 0 00.88 1.033l.033.033c.725.502 1.595.517 2.454.173.863-.345 1.622-1.027 2.034-1.761.322-1.333.117-2.538-.414-3.369-.529-.828-1.404-1.334-2.566-1.253-.645.045-1.494.238-2.161.715-.627.448-1.147 1.18-1.148 2.47z",
  fill: "#40220F"
});

var SvgIconRick2 = function SvgIconRick2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 88,
    fill: "none"
  }, props), _ref, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "icon_rick_2_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 64,
    width: 25,
    height: 18
  }, _ref4), _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "icon_rick_2_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 1,
    width: 11,
    height: 19
  }, _ref8), _ref9, _ref10, _ref11, /*#__PURE__*/React.createElement("mask", {
    id: "icon_rick_2_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 1,
    width: 11,
    height: 19
  }, _ref12), _ref13, _ref14, _ref15, /*#__PURE__*/React.createElement("mask", {
    id: "icon_rick_2_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 20,
    width: 51,
    height: 42
  }, _ref16), _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34);
};

export default SvgIconRick2;